<template>
	<section style="overflow-y: auto;height: calc(100vh - 110px);">
		<el-container>
			<el-header style="height: auto;padding-left: 0px;"><!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-form :inline="true" :model="filters" class="filterForm">
						<el-form-item label="关键词:" label-width="100px">
							<el-input v-model="filters.kw" auto-complete="off" class="formItem" size="small" placeholder="输入题目名,题号"/>
						</el-form-item>
						<el-form-item label="题目类型:" label-width="100px">
							<el-select v-model="filters.proType" placeholder="请选择" size="small" class="formItem"
								clearable>
								<el-option v-for="item in proTypeDict" :key="item.valuekey" :label="item.textkey"
									:value="item.valuekey">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="难易度:" label-width="100px">
							<el-select v-model="filters.proLevel" placeholder="请选择" size="small" class="formItem"
								clearable>
								<el-option v-for="item in proLevelDict" :key="item.valuekey" :label="item.textkey"
									:value="item.valuekey">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="添加时间:" label-width="100px">
							<el-date-picker type="daterange" v-model="addTimes" value-format="yyyy-MM-dd" class="formItem"
								size="small"></el-date-picker>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
							<el-button type="primary" @click="addInfo" size="small">新增</el-button>
							<!-- <el-button type="primary" @click="() => { dialogImportShow = true }" size="small">导入excel</el-button> -->
							<el-button type="primary" @click="() => { dialogImportWordShow = true }" size="small">导入word</el-button>
							<span>&nbsp;&nbsp;</span>
							<el-dropdown  @command="handleLevelCommand" trigger="click">
							<el-button size="small" type="primary" >改难度<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="item.valuekey" v-for="item in proLevelDict" :key="item.valuekey">{{item.textkey}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
													<span>&nbsp;&nbsp;</span>
						 <el-button type="primary" @click="delBatchInfo" size="small">删除</el-button>
						</el-form-item>
					</el-form>
				</el-col>
			</el-header>
			<el-container>
				<el-aside width="250px" style="border: 1px solid #ccc;margin-top:0px;overflow-y: auto;height: calc(100vh - 220px);">
					<el-tree ref="gyszlTree"
						:data="treeData" node-key="id" :props="defaultProps" :default-expanded-keys="defaultKeys"
						@node-click="handleNodeClick" highlight-current>
						<span class="custom-tree-node" slot-scope="{ node, data }">
							<span>{{ data.isHide==1?'【隐藏】':'' }}{{ node.label }}</span>
						</span>
					</el-tree>
				</el-aside>
				<el-main style="padding-left: 0px;padding-top: 0px;"> <!--列表-->
					<el-table :data="grid_data" height="calc(100vh - 240px)" border highlight-current-row
						v-loading="listLoading" @selection-change="(v) => { sels = v }" style="width: 100%;">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column prop="proTypeName" label="题目类型" width="80"></el-table-column>
						<el-table-column prop="proNo" label="题号" width="80"></el-table-column>
						<el-table-column prop="proName" label="题目" width="180" show-overflow-tooltip></el-table-column>

						<!-- <el-table-column prop="proScores" label="分值" width="150"></el-table-column> -->
						<el-table-column prop="gradeName" label="年级" width="100"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="unitName" label="单元" width="85" show-overflow-tooltip></el-table-column>
						<el-table-column prop="proLevelName" label="难易度" width="80"></el-table-column>
						<!-- <el-table-column prop="lorePointName" label="知识点" width="100"
							show-overflow-tooltip></el-table-column> -->
						<el-table-column prop="addTime" label="添加时间" width="140" :formatter="$util.dateFormatEx"></el-table-column>
						<!-- <el-table-column prop="status" label="启用" width="60"
							:formatter="$util.yesOrNo"></el-table-column> -->
						<el-table-column label="操作" min-width="160" fixed="right">
							<template scope="scope">
								<el-button size="small" @click="editInfo(scope.$index, scope.row)">编辑</el-button>
								<!-- <el-button size="small" @click="updateStatus(scope.$index, scope.row)"
									v-if="scope.row.status == 1">停用</el-button>
								<el-button size="small" @click="updateStatus(scope.$index, scope.row)"
									v-else>启用</el-button> -->
								<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!--分页-->
					<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
						@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>
				</el-main>
			</el-container>
		</el-container>

		<addsave :showTitle="showTitle" :dialogAddShow="dialogAddShow" :mid="mid" fromType="2" @saveCallBack="saveCallBack"
			@getVisible="(v) => { dialogAddShow = v }"></addsave>
		<importxls :showTitle="String('导入excel题库')" :dialogShow="dialogImportShow" templateName="templateexercise"
			importUrl="/exercise/importexerciseinfo" @callBack="importCallBack"></importxls>
			<importword :showTitle="String('导入word题库')" :dialogShow="dialogImportWordShow" fromType="2" templateName="templateexercise"
			importUrl="/exercise/importwordexerciseinfomatch" @callBack="importWordCallBack"></importword>
	</section>
</template>

<script>

import pagination from '@/components/common/pagination.vue'
import addsave from './exerciseinfoadd.vue'
import importxls from '@/components/importXls.vue';
import importword from '@/components/importWord.vue';
export default {
	components: { addsave, pagination, importxls ,importword},
	data() {
		return {
			filters: {
				proType: '',
				kw: '',
				proLevel: '',
				gradeId: '',
				unitId: '',
				lorePointId: '',
				chapterId:'',
				addTime: '',
				addTime2: '',
				schoolId: '',
				status: '',
				fromType:2,
				rows: 10,
				page: 1
			},
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0,
			proTypeDict: [],
			proLevelDict: [],
			schoolDict: [],
			addTimes: [],
			treeData: [],
			defaultProps: {
				children: 'children',
				label: 'groupName'
			},
			dialogImportShow: false,
			defaultKeys:[1566],
			dialogImportWordShow: false,
		}
	},
	methods: {
		//获取列表
		async getTreeData() {
			let formData = this.$util.jsonToForm({
				id: 0,
				parentId: 0,
				sortNum: 0,
				"isDrag": 0,
				showNoUnit:1,
				fromType:2
			});
			this.$axios.post("/exercise/getexercisegrouplist", formData).then(res => {
				this.treeData = [{ "id": 0, groupName: "全部", children: res.data.data, groupType: 0 ,fromType:2}]
			});
		},
		handleNodeClick(data) {
			if (data.groupType == 1) {
				this.filters.gradeId = data.id
				this.filters.unitId = ''
				this.filters.lorePointId = ''
				this.filters.chapterId=''
			}
			else if (data.groupType == 2) {
				this.filters.gradeId = ''
				this.filters.unitId = data.id
				this.filters.lorePointId = ''
				this.filters.chapterId=''
			}
			else if (data.groupType == 3) {
				this.filters.gradeId = ''
				this.filters.unitId = ''
				this.filters.lorePointId = data.id
				this.filters.chapterId=data.id
			}
			else {
				this.filters.gradeId = ''
				this.filters.unitId = ''
				this.filters.lorePointId = ''
				this.filters.chapterId=''
			}
			this.filters.page=1
			this.getGridData()
		},
		//获取列表
		getGridData() {
			this.listLoading = true;
			this.$util.dealQueryDateRange(this.filters, this.addTimes, "addTime")
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/exercise/getexerciseinfolist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;
			});
		},
		//删除
		delInfo: function (index, row) {
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(() => {
				let formData = new FormData();
				formData.append("id", row.id);
				this.$axios.post("/exercise/exerciseinfodel", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("删除成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
			});
		},
			//删除
		delBatchInfo: function () {
			if(this.sels.length==0){
				this.$message("请选择记录!");
				return
			}
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(() => {
				let formData = new FormData();
				formData.append("ids", this.sels.map(v=>{return v.id}).join(','));
				this.$axios.post("/exercise/exerciseinfobatchdel", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("删除成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
			});
		},
		addInfo: function () {
			this.showTitle = "新增习题";
			this.dialogAddShow = true;
			this.mid = 0;
		},
		editInfo: function (index, row) {
			this.showTitle = "编辑习题";
			this.dialogAddShow = true;
			this.mid = row.id;
		},
		updateStatus: function (index, row) {
			let formData = new FormData();
			formData.append("id", row.id);
			formData.append("status", row.status == 1 ? 0 : 1)
			this.$axios.post("/exercise/exerciseinfupdate_status", formData).then(res => {
				if (res.data.status == 0) {
					this.$message(row.status == 1 ? "停用" : "启用" + "成功!");
					this.getGridData();
				} else {
					this.$message(res.data.msg);
				}
			});
		},
		importCallBack() {
			this.dialogImportShow = false
			this.getGridData();
		},
		importWordCallBack() {
			this.dialogImportWordShow = false
			this.getGridData();
		},
		saveCallBack: function (id,addType) {
			if(addType!=null && addType==2){
			}
			else{
				this.dialogAddShow = false;
			}

			if (this.mid == 0) {
				this.handleCurrentChange(1);
			}
			else {
				this.getGridData();
			}
		},
		handleLevelCommand(command){
			if(this.sels.length==0){
				this.$message("请选择记录!");
				return
			}
			let formData = new FormData();
				formData.append("ids", this.sels.map(v=>{return v.id}).join(','));
				formData.append("level",Number(command))
				this.$axios.post("/exercise/exerciseinfupdate_level", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("设置成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
		}
	},
	async created() {
		await this.getTreeData()
		this.proTypeDict = (await this.getDictInfo('proType'))
		this.proLevelDict = (await this.getDictInfo('proLevel'))
		this.getGridData();
	}
}
</script>
<style scoped>
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
	background-color: #b0c4de;
}
</style>
